import React, { useState } from "react";
import { Outlet, Link, useLocation } from "react-router-dom"; // Added useLocation
import Footer from "./Footer";
// import omorelogo from "../Images/omorelogo.png"
import omorelogo from "../Images/OMG.svg";

export default function Layout() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation(); // Get current path

  const menuItems = [
    { label: "Neuralis", path: "/" },
    { label: "GAME LIBRARY", path: "/gamelibrary" },
    { label: "ABOUT OMORE", path: "/aboutomore" },
    { label: "CONTACT", path: "/contact" },
  ];

  // Helper to check if link is active
  const isActive = (path) => location.pathname === path;

  return (
    <div className="relative h-[100svh] w-full bg-[#111214] flex items-center justify-center font-sans overflow-hidden select-none">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.03),transparent_70%)] pointer-events-none" />

      {/* Main container */}
      <div className="w-full h-full md:w-[94%] md:h-[94%] bg-[#181a1f] flex flex-col relative md:rounded-[1.5rem] border border-white/[0.03] shadow-2xl overflow-y-auto overflow-x-hidden custom-scrollbar">
        {/* Header Section */}
        <header className="shrink-0 z-50 sticky top-0 bg-[#181a1f]/80 backdrop-blur-md">
          <div className="px-6 py-5 md:px-12 md:py-8 flex justify-between items-center">
            {/* Left Side: Brand */}
            {/* Left Side: Brand */}
            <Link to="/" className="group flex flex-col items-center">
              {/* The "Pop-out" Container - Height strictly locked to h-12 / md:h-14 */}
              <div className="relative flex flex-col items-center justify-center w-24 md:w-28 h-12 md:h-14 bg-zinc-950 border border-white/20 rounded-lg shadow-xl transition-all duration-300 group-hover:border-blue-500 group-hover:shadow-[0_0_15px_rgba(59,130,246,0.3)] overflow-hidden">
                {/* Logo Image - Scaled down to fit the new height */}
        <img
  src={omorelogo}
  alt="OMORE Logo"
  loading="lazy" // Added lazy loading
  className="h-5 md:h-6 w-auto object-contain transition-transform duration-300 group-hover:scale-110"
  decoding="async" // Bonus: optimizes browser decoding priority
/>

                {/* Subtext - Positioned with a tight margin */}
                <span className="mt-1 w-full text-center text-[6px] md:text-[7px] uppercase tracking-[0.2em] text-zinc-100 font-black group-hover:text-blue-400 transition-colors leading-none">
                  OMORE Games
                </span>

                {/* Subtle Glow Overlay */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 bg-gradient-to-t from-blue-500/10 to-transparent pointer-events-none transition-opacity duration-300"></div>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center gap-10">
              {menuItems.map((item) => (
                <Link
                  key={item.label}
                  to={item.path}
                  className={`text-[10px] uppercase tracking-[0.3em] transition-all relative group ${
                    isActive(item.path) ? "text-white" : "text-zinc-200 hover:text-white"
                  }`}
                >
                  {item.label}
                  <span
                    className={`absolute -bottom-2 left-0 h-[1px] bg-blue-500 transition-all ${
                      isActive(item.path) ? "w-full" : "w-0 group-hover:w-full"
                    }`}
                  />
                </Link>
              ))}
            </nav>

            {/* Right Side: Mobile Toggle & Time */}
            <div className="flex items-center gap-6">
              <div className="hidden lg:block text-right">
                <p className="text-[10px] text-white/40 tracking-[0.2em] font-mono uppercase">
                  {new Date().toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </p>
              </div>

              {/* Mobile Menu Button */}
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="md:hidden flex flex-col gap-1.5 items-end group"
              >
                <div
                  className={`h-[1px] bg-white transition-all duration-300 ${isMenuOpen ? "w-6 rotate-45 translate-y-2" : "w-6"}`}
                />
                <div
                  className={`h-[1px] bg-white transition-all duration-300 ${isMenuOpen ? "opacity-0" : "w-4"}`}
                />
                <div
                  className={`h-[1px] bg-white transition-all duration-300 ${isMenuOpen ? "w-6 -rotate-45 -translate-y-[2px]" : "w-2"}`}
                />
              </button>
            </div>
          </div>
          <div className="w-full h-[1px] bg-white/[0.05]" />
        </header>

        {/* Mobile Menu Overlay */}
        <div
          className={`
          fixed inset-0 z-40 bg-[#111214] transition-all duration-500 md:hidden
          ${isMenuOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}
        `}
        >
          <div className="flex flex-col items-center justify-center h-full gap-12">
            {menuItems.map((item, i) => (
              <Link
                key={item.label}
                to={item.path}
                onClick={() => setIsMenuOpen(false)}
                className={`text-2xl font-black uppercase tracking-[0.5em] transition-all ${
                  isActive(item.path)
                    ? "text-blue-500"
                    : "text-zinc-700 hover:text-blue-500"
                }`}
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Main content */}
        <main className="flex-1 relative flex flex-col">
          <div className="w-full h-full">
            <Outlet />
          </div>
          <Footer version="1.0.4" />
        </main>

        {/* Footer */}
        <footer className="shrink-0 w-full mt-auto">
          <div className="h-[1px] w-full bg-white/[0.05]">
            <div className="h-full bg-blue-500/40 w-[20%] transition-all duration-700 ease-in-out shadow-[0_0_10px_rgba(59,130,246,0.3)]" />
          </div>
          <div className="h-[env(safe-area-inset-bottom)] md:h-4" />
        </footer>
      </div>
    </div>
  );
}
